import { useEffect } from "react";
import packageJson from '../../package.json';

export default function useAutoUpdate(interval = 3600000) {
    const currentVersion = packageJson.version;

    useEffect(() => {
        const checkVersion = async () => {
            try {
                const response = await fetch("/version.json?_=" + Date.now());
                const { version } = await response.json();
                console.log("Current version:", currentVersion, "Fetched version:", version);
                if (version && version !== currentVersion) {
                    console.log("New version detected, reloading...");
                    // window.location.reload();
                }
            } catch (e) {
                console.error("Version check failed:", e);
            }
        };

        const timer = setInterval(checkVersion, interval);
        checkVersion();

        return () => clearInterval(timer);
    }, [currentVersion, interval]);
}
